/* eslint no-unused-vars:off */
import { fetchProductsList } from "@/apps/dashboard/catalog/core/infrastructure/repository/productsRepository";
import { Product } from "@/core/models/product";
import {
  ProductSearchFilterOptions,
  saveFilters,
} from "@/apps/dashboard/catalog/core/infrastructure/service/productFiltersService";

export enum ProductStatusType {
  PUBLISHED = "published",
  DRAFT = "draft",
}

export type ProductsList = {
  items: Product[];
  totalItems: number;
};

export const getProductsList = async (options: ProductSearchFilterOptions): Promise<ProductsList> => {
  saveFilters(options);

  return fetchProductsList(options);
};
